import axios from 'axios'
// import config from './config'
import qs from 'qs'
import Vue from 'vue'
import router from '@/router'
const config ={
    method: 'POST'
}
let loadingCount = 0,loading
const white = ['/register'] 

// 不返错误信息的接口
const apiWhite = ['getLogo', 'getQuestionTypeByTaskIdAndCourseId', 'submitQuestion']
function filterApiMessage(url) {
  let temp = url.split('/')
  let apiName = temp[temp.length - 1]
  return apiWhite.includes(apiName)
}

const request = options => {
  options.headers = {
    "Content-Type" : options.isUpload ? 'multipart/form-data' : 'application/x-www-form-urlencoded',
  }

  const { $event } = Vue.prototype
  if (loadingCount < 1) {
    if ( 
      router.history.current.name == 'dataV_B' ||
      router.history.current.name == 'dataV_A' ||
      router.history.current.name == 'dataV_C'
    ) {
      loading.close()
    } else {
      loading = $event.$loading({background:'transparent'})
    }
  }




  loadingCount++
  return new Promise((resolve, reject) => {
    const instance = axios.create(config)
    // 添加请求拦截器
    instance.interceptors.request.use(function (config) {
      // 在发送请求之前做些什么
      if (!options.isUpload) {
        config.data = qs.stringify(config.data)
      }

      return config;
    }, function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
    });

    // 添加响应拦截器
    instance.interceptors.response.use(function (response) {
      loadingCount--
      if (loadingCount < 1) {
        setTimeout(() => {
          loading.close()
        },200)
      }
      if (response.config.url.includes('imageCheckCode')) {
          return response
      }
      // 对响应数据做点什么
      if (response.data.code === 0 && !filterApiMessage(options.url)) {
        if(response.data.error){
          if(response.data.error.msg){
            let msgDuration= response.data.error.length>30 ? 5000 : 3000
          $event.$message({
            type: 'error',
            message: response.data.error.msg,
            duration: msgDuration
          });
          if(response.data.error.code === 1001) {
            let { path } = router.app.$route
            if (white.indexOf(path) === -1) {
              let tenant = window.localStorage.getItem("tenant")
              router.push({name:'Login',query:{'tenant':tenant}})
              window.localStorage.clear()
            }
          }else if (response.data.error.code === 1002 && localStorage.getItem('userInfo')) {
            let loc = localStorage.getItem('userInfo')
            loc = JSON.parse(loc)
            if(loc.roleType === 2) {
                // router.push({name:'stuApply'})
            } else {
                router.push({name:'index'})
            }
          }
          }
          
        }
      }
      return response.data;
    }, function (error) {
      loadingCount--
      if (loadingCount < 1) {
        setTimeout(() => {
          loading.close()
        },200)
      }
      const { status, data} = error.response
      if(status==500&&options.url=="/api/sign/auth/login"){
         let msgDuration= data.error.length>30 ? 5000 : 3000
         $event.$message({
          type: 'error',
          message: "找不到指定的租户，请确认租户名称",
          duration: msgDuration
        });
        return false
      }
      if (status != 200 && data.code == 0 && !filterApiMessage(options.url)) {
        let msgDuration= data.error.length>30 ? 5000 : 3000
        $event.$message({
          type: 'error',
          message: `${data.error.msg}`,
          duration: msgDuration
        });
      }
      // 对响应错误做点什么
      return Promise.reject(error);
    });

    
    instance.request(options)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export default request
